import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1A2332] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/4d51c752-8b5a-4cb2-9529-496834109266.png"
              alt="Wharfedale Plumbing & Heating"
              className="h-12 w-auto mb-6"
            />
            <div className="space-y-3 text-gray-400 text-sm">
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                01943 123 456
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                info@wharfedaleplumbing.co.uk
              </p>
              <p className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                <span>Otley, West Yorkshire<br />LS21 3AA</span>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-400 uppercase text-sm font-semibold mb-6 tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white hover:text-gray-300 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white hover:text-gray-300 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white hover:text-gray-300 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-gray-300 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-gray-400 uppercase text-sm font-semibold mb-6 tracking-wider">
              Services
            </h3>
            <ul className="space-y-3">
              <li className="text-white">Emergency Plumbing</li>
              <li className="text-white">Boiler Installation</li>
              <li className="text-white">Central Heating</li>
              <li className="text-white">Plumbing Maintenance</li>
              <li className="text-white">Bathroom Installation</li>
            </ul>
          </div>

          {/* Follow Us */}
          <div>
            <h3 className="text-gray-400 uppercase text-sm font-semibold mb-6 tracking-wider">
              Follow Us
            </h3>
            <div className="flex space-x-4 mb-6">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>© 2025 Wharfedale Plumbing & Heating. All rights reserved.</p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors mt-4 md:mt-0"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;